// -*- Mode: rjsx -*-

import React  from 'react';
import EmailIcon from '@mui/icons-material/MailOutline';

function EmailSent() {
    return (
        <div className="center-text">
          <EmailIcon style={{ fontSize: "127" }} />
          <h2>Check your email!</h2>
        </div>
    );p
}

export default EmailSent;
